<template>
  <div class="attrCard">
    <h3>{{ label }}</h3>
    <p>{{ value }}</p>
    <div class="attrCard-icon"></div>
  </div>
</template>

<script>
export default {
  name: "riskTip",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.attrCard {
  position: relative;
  height: 80px;
  margin-bottom: 28px;
  padding-left: 1.5em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // align-items: center;
  font-size: 17px;
  line-height: 1.2;
  box-shadow: 0 13px 0 -8px $--background-color-light;
  border-radius: $--border-radius-large;
  border: 1px solid $--border-color-light;
  background: #f6f6f6;
  background-image: linear-gradient(
    124deg,
    rgba(236, 16, 45, 0.03) 0%,
    rgba(236, 16, 45, 0) 91%
  );

  // &:before {
  //   content: "";
  //   position: absolute;
  //   z-index: 0;
  //   width: 80%;
  //   bottom: -20px;
  //   height: 100%;
  //   background: $--background-color-light;
  // }
  h3 {
    position: relative;
    z-index: 9;
    font-size: 1em;
    font-weight: normal;
    line-height: 1.2;
    word-break: break-all;
    margin: 0.3em 0 0.5em;
    color: $--color-text-regular;
    &::before {
      content: "●";
      font-size: 0.6em;
      position: absolute;
      left: -1.2em;
      top: 50%;
      transform: translateY(-50%);
      color: $--color-primary;
    }
  }
  p {
    position: relative;
    z-index: 9;
    font-size: 1.4em;
    color: $--color-text-primary;
    cursor: pointer;
  }
  &-icon {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
    width: 54px;
    height: 54px;
    background: url("~@/assets/img/icon_tongji.png") no-repeat center;
    background-size: contain;
  }
}
@media screen and (max-width: $--lg) {
  .attrCard {
    font-size: $--font-size-base;
    padding: 0 1.5em;
  }
}
</style>
